const BASE_URL = 'https://app.ticketmaster.com/discovery/v2/';
const KEY = 'w2rp7JjXdCoAjtGRKPPDY9cIXNULMVug';

export { BASE_URL };
export { KEY };